import clsx from 'clsx'
import styles from './PBStep.module.scss'

export const PBStep = ({ step, label, isActive }) => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['number'], isActive ? styles['number--active'] : styles['number--default'])}>
        <span className={styles['number__text']}>{step}</span>
      </div>

      <span className={clsx(styles['label'], isActive ? styles['label--active'] : styles['label--default'])}>{label}</span>
    </div>
  )
}
